export default "__VITE_ASSET__5oRx4FiF__"